import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useMemo } from 'react';

import { updateWorkOrderChange } from '../WorkOrderChangeQueries';

export const useUpdateWorkOrderChange = () => {
    const [
        updateWorkOrderChangeData,
        updateWorkOrderChangeStatus,
        updateWorkOrderChangeErr,
        updateWorkOrderChangeRequest,
    ] = useRequest({
        requestId: 'updateWorkOrderChange',
        query: updateWorkOrderChange,
        withEffect: false,
    });

    const [resetUpdateData] = useResetStoreData({ requestId: 'updateWorkOrderChange' });

    const isUpdatingInProgress = useMemo(
        () => updateWorkOrderChangeStatus === RequestStatus.FETCHING,
        [updateWorkOrderChangeStatus],
    );

    return {
        updatingData: updateWorkOrderChangeData?.uerUpdateWorkOrderChange,
        updatingStatus: updateWorkOrderChangeStatus,
        updatingErr: updateWorkOrderChangeErr,
        updatingRequest: updateWorkOrderChangeRequest,
        resetUpdateData,
        isUpdatingInProgress,
    };
};
